import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const Link = (props) => {
  return (
  /*  <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="13"
      viewBox="0 0 24 20"
      width="18"
      style={ { paddingTop:"0px", paddingLeft:"2px" } }>
      
      <path d="M17.3,13.35a1,1,0,0,1-.7-.29,1,1,0,0,1,0-1.41l2.12-2.12a2,2,0,0,0,0-2.83L17.3,5.28a2.06,2.06,0,0,0-2.83,0L12.35,7.4A1,1,0,0,1,10.94,6l2.12-2.12a4.1,4.1,0,0,1,5.66,0l1.41,1.41a4,4,0,0,1,0,5.66L18,13.06A1,1,0,0,1,17.3,13.35Z" />
      <path d="M8.11,21.3a4,4,0,0,1-2.83-1.17L3.87,18.72a4,4,0,0,1,0-5.66L6,10.94A1,1,0,0,1,7.4,12.35L5.28,14.47a2,2,0,0,0,0,2.83L6.7,18.72a2.06,2.06,0,0,0,2.83,0l2.12-2.12A1,1,0,1,1,13.06,18l-2.12,2.12A4,4,0,0,1,8.11,21.3Z" />
      <path d="M8.82,16.18a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l6.37-6.36a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.42L9.52,15.89A1,1,0,0,1,8.82,16.18Z" />


     </svg>*/

<svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
width="11.000000pt" height="11.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M1116 3829 c-477 -62 -895 -404 -1046 -857 -50 -152 -64 -242 -64
-412 0 -171 14 -260 65 -415 121 -362 433 -674 797 -795 193 -64 181 -63 835
-67 l597 -4 0 245 0 245 -587 3 c-587 3 -588 3 -658 27 -268 90 -454 277 -537
541 -20 64 -23 96 -23 220 0 124 3 156 23 220 83 264 269 451 537 541 70 24
71 24 658 27 l587 3 0 244 0 245 -557 -1 c-307 -1 -589 -5 -627 -10z"/>
<path d="M2820 3596 l0 -245 588 -3 c586 -3 587 -3 657 -27 268 -90 454 -277
537 -541 20 -64 23 -96 23 -220 0 -124 -3 -156 -23 -220 -83 -264 -269 -451
-537 -541 -70 -24 -71 -24 -657 -27 l-588 -3 0 -245 0 -245 598 4 c653 4 641
3 834 67 364 121 676 433 797 795 51 155 65 244 65 415 0 170 -14 260 -64 412
-122 364 -433 677 -795 797 -197 65 -183 64 -837 68 l-598 4 0 -245z"/>
<path d="M1540 2560 l0 -260 1020 0 1020 0 0 260 0 260 -1020 0 -1020 0 0
-260z"/>
</g>
</svg>


  );
};

export default Link;
